import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const WmIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "8.08909",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M23.6134 27.0611C25.382 27.0611 26.8158 25.6274 26.8158 23.8588C26.8158 22.0902 25.382 20.6565 23.6134 20.6565C21.8449 20.6565 20.4111 22.0902 20.4111 23.8588C20.4111 25.6274 21.8449 27.0611 23.6134 27.0611Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M23.6134 16.078C25.382 16.078 26.8158 14.6442 26.8158 12.8757C26.8158 11.1071 25.382 9.67334 23.6134 9.67334C21.8449 9.67334 20.4111 11.1071 20.4111 12.8757C20.4111 14.6442 21.8449 16.078 23.6134 16.078Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.1652 23.669C14.9338 23.669 16.3675 22.2353 16.3675 20.4667C16.3675 18.6981 14.9338 17.2644 13.1652 17.2644C11.3966 17.2644 9.96289 18.6981 9.96289 20.4667C9.96289 22.2353 11.3966 23.669 13.1652 23.669Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.1545 35.9488C18.9231 35.9488 20.3568 34.5151 20.3568 32.7465C20.3568 30.9779 18.9231 29.5442 17.1545 29.5442C15.3859 29.5442 13.9521 30.9779 13.9521 32.7465C13.9521 34.5151 15.3859 35.9488 17.1545 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M30.0656 35.9488C31.8342 35.9488 33.2679 34.5151 33.2679 32.7465C33.2679 30.9779 31.8342 29.5442 30.0656 29.5442C28.297 29.5442 26.8633 30.9779 26.8633 32.7465C26.8633 34.5151 28.297 35.9488 30.0656 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M34.0597 23.669C35.8283 23.669 37.2621 22.2353 37.2621 20.4667C37.2621 18.6981 35.8283 17.2644 34.0597 17.2644C32.2911 17.2644 30.8574 18.6981 30.8574 20.4667C30.8574 22.2353 32.2911 23.669 34.0597 23.669Z",
                fill: "white"
            })
        ]
    });
